/**
 * @desc 下载导入dono关系模板文件
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBox/downloadBindDonoTemplate`, {
      method: "POST",

      ...options,
    }),
  );
}
